import { Box, Button, Text } from '@landtrustinc/design-system';
import React from 'react';

import type { AnalyticsHandler } from '../../SignupDrawer/hooks/useSignupFlow';
import { useConfirmationStep } from '../hooks/useConfirmationStep';
import LtPlusBenefitsList from './LtPlusBenefitsList';
import LtPlusStepLayout from './LtPlusStepLayout';

type ConfirmationStepProps = {
  benefits: string[];
  onDone: () => void;
  onAnalyticsEvent?: AnalyticsHandler;
};

const ConfirmationStep: React.FC<ConfirmationStepProps> = ({
  benefits,
  onDone,
  onAnalyticsEvent,
}) => {
  const { handleDone } = useConfirmationStep({
    onDone,
    onAnalyticsEvent,
  });

  return (
    <LtPlusStepLayout title="You're All Set!">
      <Text textAlign="center">
        You&apos;ve successfully upgraded to LandTrust Plus! Start taking advantage of your perks
        today.
      </Text>

      <LtPlusBenefitsList benefits={benefits} helperText="Your subscription includes:" />

      <Box mt="var(--spacing-4)" width="100%">
        <Button variant="plus" fullWidth onClick={handleDone}>
          Done
        </Button>
      </Box>
    </LtPlusStepLayout>
  );
};

export default ConfirmationStep;
